import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { InputField } from 'src/components';
import { config } from 'src/config';
import store from 'src/rtk/app/store';

interface Props {
    isOpen: boolean;
    toggle: any;
}

function numberToWords(num: number): string {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion'];

    if (num === 0) return 'Zero';

    let words = '';
    let i = 0;
    while (num > 0) {
        if (num % 1000 !== 0) {
            words = helper(num % 1000) + thousands[i] + ' ' + words;
        }
        num = Math.floor(num / 1000);
        i++;
    }
    return words.trim();

    function helper(n: number): string {
        let str = '';
        if (n >= 100) {
            str += units[Math.floor(n / 100)] + ' Hundred ';
            n %= 100;
        }
        if (n >= 20) {
            str += tens[Math.floor(n / 10)] + ' ';
            n %= 10;
        } else if (n >= 10) {
            str += teens[n - 10] + ' ';
            return str;
        }
        if (n > 0) {
            str += units[n] + ' ';
        }
        return str;
    }
}

const PaymentModal = (props: any) => {
    const { isOpen, toggle, instituteName, feesInWord, instituteFees, type, id } = props;
    const [onlinePayment, setOnlinePayment] = useState<boolean>(false);
    const [offlinePayment, setOfflinePayment] = useState<boolean>(true);
    const [pageShow, setPageShow] = useState<boolean>(false);
    const [location, setLocation] = useState<string>('');

    const pageShowHandler = (modalState: boolean) => {
        setPageShow(modalState);
    };

    let totalFees = Number(instituteFees);
    if (type === 'Private') {
        if (location === 'inside') {
            totalFees += 20000;
        } else if (location === 'outside') {
            totalFees += 40000;
        }
    }
    const newFeesInWord = numberToWords(totalFees);


    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop={'static'} size="md">
            <ModalHeader toggle={toggle}>Apply for Training Institute Accreditation</ModalHeader>

            <ModalBody>
                <div className='table-responsive'>
                    <table className='table table-bordered'>
                        <tbody>
                            <tr>
                                <td><strong>Institute Name: </strong></td>
                                <td>
                                    {instituteName}
                                </td>
                            </tr>
                            {type === 'Private' && (
                                <tr>
                                    <td><strong>Location:</strong></td>
                                    <td>
                                        <InputField
                                            type="select"
                                            name="location"
                                            options={[
                                                { label: 'Inside Dhaka', value: 'inside' },
                                                { label: 'Outside Dhaka', value: 'outside' },
                                            ]}
                                            value={location}
                                            onChange={(e) => setLocation(e.target.value)}
                                        />
                                    </td>
                                </tr>)}

                            <tr>
                                <td><strong>Fees: </strong></td>
                                <td>
                                    {totalFees} ({newFeesInWord})
                                </td>
                            </tr>

                            <tr>
                                <td><strong>Payment Mode:</strong></td>
                                <td>
                                    <Form
                                        className="custom-form"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                        }}
                                        onReset={(e) => {
                                            e.preventDefault();
                                        }}
                                    >

                                        <FormGroup check inline>
                                            <Input
                                                id='paymentMode1'
                                                name='payment_mode'
                                                type='radio'
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setOnlinePayment(true);
                                                        setOfflinePayment(false);
                                                    }
                                                }}
                                                checked={onlinePayment}
                                                value={'Online'}
                                            />

                                            <Label check for="paymentMode1">
                                                Online
                                            </Label>
                                        </FormGroup>

                                        <FormGroup check inline>
                                            <Input
                                                id='paymentMode2'
                                                name='payment_mode'
                                                type='radio'
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setOnlinePayment(false);
                                                        setOfflinePayment(true);
                                                    }
                                                }}
                                                checked={offlinePayment}
                                                value={'Offline'}
                                            />

                                            <Label check for="paymentMode2">
                                                Offline
                                            </Label>
                                        </FormGroup>

                                    </Form>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ModalBody>

            <ModalFooter>
                <div className="d-flex gap-2">
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                    {
                        offlinePayment ? (
                            (type === 'Private' && !location) ? (
                                <Button color="success" disabled>
                                    Proceed for Payment
                                </Button>
                            ) : (
                                <Link to={{ pathname: `/institute-offline-payment/${'Institute'}/${id}/${totalFees}` }} className='btn btn-success'>
                                    Proceed for Payment
                                </Link>
                            )
                        ) : null
                    }

                    {
                        onlinePayment ? (
                            (type === 'Private' && !location) ? (
                                <Button color="success" disabled>
                                    Proceed for Payment
                                </Button>
                            ) : (
                                <a href={`${config.APP_URL}fcps-online-payment/${id}/${store.getState().auth.user.id}/${totalFees}?type=institute`} rel='noreferrer' target={'_blank'} className='btn btn-success'>
                                    Proceed for Payment
                                </a>
                            )
                        ) : null
                    }

                </div>
            </ModalFooter>
        </Modal>
    );
};

export default PaymentModal;
